export default __webpack_public_path__ + "static/media/events-crud.d35581e4.jpg";